import { registerSW } from 'virtual:pwa-register';
import type { PwaController } from './PwaController';

export const registerPwa = (controller: PwaController): void => {
  let updateServiceWorker: (reloadPage?: boolean) => Promise<void>;
  updateServiceWorker = registerSW({
    immediate: true,
    onNeedRefresh: () => controller.offerUpdate(() => updateServiceWorker(true)),
    onOfflineReady: () => controller.setOfflineReady(),
  });
};
